import React from "react";
import LInkedIn from "../../imgs/icons/linkedIn.svg";
import GitHub from "../../imgs/icons/git.svg";
import TitleButton from "../Title Button/TitleButton";

function About() {
  return (
    <section
      id='about'
      className='w-full border-b border-line bg-background py-20 md:py-28'
    >
      <div className='swiss-container'>
        <TitleButton title={"About"} number={"01"} />

        {/* Section headline */}
        <div className='mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:items-end'>
          <h2 className='font-heading text-3xl font-extrabold uppercase leading-[0.95] tracking-tighter text-primary sm:text-4xl md:text-5xl lg:col-span-8'>
            Transforming ideas
            <br />
            <span className='text-primary/55'>into reality</span>
          </h2>
          <p className='font-body text-sm leading-relaxed text-primary/55 md:text-base lg:col-span-4'>
            A developer dedicated to building innovative, functional digital
            solutions.
          </p>
        </div>

        {/* Body grid */}
        <div className='mt-16 grid grid-cols-1 gap-x-10 gap-y-12 border-t border-line pt-16 lg:grid-cols-12'>
          {/* Copy */}
          <div className='flex flex-col gap-10 lg:col-span-6'>
            <h3 className='font-heading text-2xl font-bold leading-tight tracking-tight text-primary md:text-3xl'>
              I solve complex problems with elegant, maintainable code.
            </h3>

            <div className='space-y-5 font-body text-base leading-relaxed text-primary/65'>
              <p>
                With a foundation in both practical IT implementation and
                Computer Science principles, I approach web development as a
                craft. I don't just write code; I architect solutions that are
                scalable, maintainable, and visually precise.
              </p>
              <p>
                My drive for continuous learning keeps me current with modern
                web technologies, letting me turn ambitious ideas into seamless
                digital experiences from backend architecture to pixel-accurate
                interfaces.
              </p>
            </div>

            {/* Connect */}
            <div className='flex items-center gap-6 border-t border-line pt-8'>
              <span className='font-body text-2xs font-medium uppercase tracking-widest text-primary/45'>
                Connect
              </span>
              <div className='flex gap-3'>
                <a
                  href='https://www.linkedin.com/in/zin-myo-win/'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='flex h-12 w-12 items-center justify-center border border-primary/30 transition-colors hover:border-primary hover:bg-primary group'
                  aria-label='LinkedIn'
                >
                  <img
                    src={LInkedIn}
                    alt='LinkedIn'
                    className='h-5 w-5 brightness-0 invert transition group-hover:invert-0'
                  />
                </a>
                <a
                  href='https://github.com/ZinMyoWin'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='flex h-12 w-12 items-center justify-center border border-primary/30 transition-colors hover:border-primary hover:bg-primary group'
                  aria-label='GitHub'
                >
                  <img
                    src={GitHub}
                    alt='GitHub'
                    className='h-5 w-5 brightness-0 invert transition group-hover:invert-0'
                  />
                </a>
              </div>
            </div>
          </div>

          {/* Intro video — flat, grid-aligned */}
          <div className='lg:col-span-6'>
            <div className='relative aspect-video w-full overflow-hidden border border-line bg-secondary'>
              <iframe
                src='https://www.youtube.com/embed/VwBunf2hroQ?si=hBoFmaPR3-BX9oQT'
                title='Zin Myo Win Introduction'
                frameBorder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share'
                referrerPolicy='strict-origin-when-cross-origin'
                allowFullScreen
                className='absolute inset-0 h-full w-full'
              />
            </div>
            <div className='flex items-baseline justify-between border-x border-b border-line px-4 py-3'>
              <span className='font-body text-2xs font-medium uppercase tracking-widest text-primary/45'>
                Introduction Reel
              </span>
              <span className='font-body text-2xs uppercase tracking-widest text-primary/40'>
                Fig. 02
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
